import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input()
  message!: string

  @Input()
  actionButtonText: string | null = null

  @Output()
  actionClick = new EventEmitter<void>()

  onActionClick() {
    this.actionClick.emit()
  }
}
